import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, ButtonElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type ButtonProps = RecursivePartial<ButtonElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | ButtonElement["children"] | string;
  data?: ButtonElement["data"];
  logic?: ButtonElement["logic"];
};

export function Button(props: ButtonProps) {
  const { data, children: propsChildren, idx, ...rest } = props;
  const node: ButtonElement = {
    type: BasicType.BUTTON,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
